<template>
  <div class="action-jigsaw-container" :class="device.isMobile ? 'action-jigsaw-container-mobile' : ''">
    <div class="reset" v-if="showReset" @click="reset(true)"></div>
    <div class="title" v-if="content.title">{{ content.title }}</div>
    <div
      class="action-background"
      :style="{
        width: content.width ? `${content.width}rem` : '',
        height: content.height ? `${content.height}rem` : '',
      }"
      @click="radioVisible = false"
    >
      <div class="background-image">
        <img :src="content.cover">
      </div>
      <div class="action-position-list">
        <div
          class="action-position-item"
          :class="item.hideCenterPoint === 1 ? 'action-position-no-center-item' : ''"
          v-for="(item, index) in handleData"
          :key="index"
          @click.stop="showRadio($event, item, index)"
          :style="{
            left: item.left ? `${item.left}rem` : '',
            top: item.top ? `${item.top}rem` : '',
            width: item.width ? `${item.width}rem` : '',
            height: item.height ? `${item.height}rem` : '',
            border: item.hideBack === 1 ? '0' : '',
            backgroundColor: item.hideBack === 1 ? 'transparent' : '',
          }"
        >
          <div
            v-if="radioVisible && activeRadio === index && item.isComplete != 1"
            class="radio-box"
            :class="item.radioPosition === 'left' ? 'radio-box-left' : ''"
          >
            <el-radio-group
              v-model="item.user_answer"
              @change="radioChangeHandle(item, index)"
            >
              <el-radio
                v-for="(opt, idx) in (item.options || content.options)"
                :label="opt.value"
                :key="idx"
                :class="
                  item.user_answer === opt.value &&
                  (
                    Array.isArray(item.answerKey) ? !item.answerKey.includes(opt.value) : (item.answerKey !== opt.value)
                  ) ? 'radio-false' : ''
                "
              >
                <img class="radio-img" v-if="opt.image" :src="opt.image" alt="">
                <template v-else>{{ opt.label }}</template>
              </el-radio>
            </el-radio-group>
          </div>
          <div
            class="isTrue"
            :class="[
              !item.hideCenterPoint ? 'isTrue-example' : '',
              (item.options || content.options).find(opt => 
                Array.isArray(item.answerKey) ? item.answerKey.includes(opt.value) : (opt.value === item.answerKey)
              ).image ? 'isTrue-image' : '',
              item.answerPosition === 'left' ? 'isTrue-left' : item.answerPosition === 'right' ? 'isTrue-right' : item.answerPosition === 'top' ? 'isTrue-top' : '',
              item.answerInBlock === 1 ? 'isTrue-in-block' : ''
            ]"
            v-if="item.isComplete == 1"
          >
            <template v-if="!Array.isArray(item.answerKey)">
              <img
                class="radio-img"
                v-if="(item.options || content.options).find(opt => opt.value === item.answerKey).image"
                :src="(item.options || content.options).find(opt => opt.value === item.answerKey).image"
                alt=""
              >
              <template v-else>{{ (item.options || content.options).find(opt => opt.value === item.answerKey).label }}</template>
            </template>
            <div class="isTrue-content" v-else>
              <div class="isTrue-item" v-for="(answer, answerIndex) in item.answerKey" :key="answerIndex">
                <img
                  class="radio-img"
                  v-if="(item.options || content.options).find(opt => opt.value === answer).image"
                  :src="(item.options || content.options).find(opt => opt.value === answer).image"
                  alt=""
                >
                <template v-else>{{ (item.options || content.options).find(opt => opt.value === answer).label }}</template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/*
交互动作组件 -- 拼图/组装
*/
import draggable from "vuedraggable";
import { getActionData, setActionData } from "@/utils/storage";
export default {
  name: "jigsawAction",
  inject: {
    findChapterFrom: {
      default: () => {},
    },
  },
  components: {
    draggable
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    },
    showReset: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      activeRadio: 0,
      radioVisible: false,
      handleData: [],
      historyData: null,
    }
  },
  mounted() {
    this.historyData = (JSON.parse(getActionData()) || {})
    console.log(this.historyData)
    let historyData = this.historyData[this.content.key]

    this.handleData = this.content.content.map((item, index) => {
      if(historyData && historyData[index] == 1) {
        item.isComplete = 1
      }else{
        item.isComplete = 2
      }
      item.user_answer = ''
      return item
    });
  },
  methods: {
    showRadio(e, item, index) {
      this.activeRadio = index
      this.radioVisible = true
      this.findChapterFrom(e)
    },
    radioChangeHandle(item, index) {
      let isComplete = false
      if(Array.isArray(item.answerKey)) {
        isComplete = item.answerKey.includes(item.user_answer)
      }else{
        isComplete = (item.answerKey == item.user_answer)
      }
      if(isComplete){
        this.handleData[index].isComplete = 1

        this.historyData = (JSON.parse(getActionData()) || {})
        let historyData = []
        historyData[this.content.key] = this.handleData.map(history => history.isComplete);
        this.historyData = Object.assign({}, this.historyData, historyData)
        setActionData(JSON.stringify(this.historyData));
      }
      this.$forceUpdate();
    },
    // 重置整个内容
    reset(delHistory) {
      this.handleData = this.handleData.map(item => {
        item.isComplete = 2
        item.user_answer = ''
        return item
      })
      this.radioVisible = false

      if(delHistory) {
        delete this.historyData[this.content.key]
        setActionData(JSON.stringify(this.historyData));
      }
    },
  },
}
</script>


<style lang="scss" scoped>
.action-jigsaw-container{
  // display: flex;
  // justify-content: space-between;
  width: 100%;
  position: relative;
  margin-top: 20rem;
  
  .reset{
    width: 34rem;
    height: 34rem;
    background: url(~@/assets/images/books/bookExample/reset.png) center center no-repeat;
    background-size: contain;
    position: absolute;
    top: -53rem;
    right: 40rem;
    cursor: pointer;
  }

  .title{
    color: #333;
    font-size: 22rem;
    padding: 0 30rem;
  }

  .action-background{
    width: 488rem;
    height: 455rem;
    margin: 0 auto;
    position: relative;

    .background-image{
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      img{
        display: block;
        height: 100%;
        width: 100% ;
      }
    }

    .action-position-list{
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;

      .action-position-item{
        border: 5rem dashed #0FC29A;
        background: rgba(15,194,154,0.25);
        display: flex;
        align-items: center;
        position: absolute;
        box-sizing: border-box;
  
        &:before{
          content: '';
          width: 27rem;
          height: 27rem;
          box-sizing: border-box;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          border: 5rem solid #0FC29A;
          background: #fff;
          border-radius: 50%;
        }
  
        .radio-box{
          background: #fff;
          position: absolute;
          top: -8rem;
          left: 100%;
          margin-left: 5rem;
          z-index: 10;
          box-shadow: 0rem 4rem 10rem 0rem #000000;
          border-radius: 6rem;
          padding: 20rem 0 10rem;

          .radio-img{
            height: 44rem;
          }

          .radio-false{
            &:before{
              content: '';
              width: 14rem;
              height: 14rem;
              background: url(~@/assets/images/books/bookExample/false-icon.png) center center no-repeat;
              background-size: contain;
              position: absolute;
              top: 50%;
              left: 3rem;
              margin-top: -7rem;
            }
          }
        }

        .radio-box-left{
          left: auto;
          right: 100%;
          margin-right: 5rem;
        }
  
        .isTrue{
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          height: 42rem;
          line-height: 42rem;
          background: #0FC29A;
          border-radius: 6rem;
          font-size: 20rem;
          color: #fff;
          padding: 0 16rem;

          .isTrue-content{
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: row-reverse;

            .isTrue-item {
              margin-left: 12rem;

              &:last-child{
                margin: 0;
              }
            }
          }
        }

        .isTrue-example{
          &:after{
            content: '';
            width: 120rem;
            height: 3rem;
            background: #0FC29A;
            position: absolute;
            top: 50%;
            right: -120rem;
            margin-top: -2rem;
          }
        }

        .isTrue-image{
          padding: 0 15rem;
          background: #fff;
          height: 52rem;
          border: 4rem solid #0FC29A;

          img{
            height: 44rem;
          }
        }
  
        &:nth-child(1) {
          .isTrue-example{
            left: -130rem;
          }
        }
  
        &:nth-child(2) {
          .isTrue-example{
            right: -330rem;

            &:after{
              content: '';
              width: 205rem;
              height: 3rem;
              background: #0FC29A;
              position: absolute;
              top: 50%;
              left: -205rem;
              margin-top: -2rem;
            }
          }
        }

        .isTrue-left{
          right: 100%;
          margin-right: 41rem;

          &:after{
            content: '';
            width: 41rem;
            height: 3rem;
            background: #0FC29A;
            position: absolute;
            top: 50%;
            left: 100%;
            margin-top: -2rem;
          }
        }

        .isTrue-right{
          left: 100%;
          margin-left: 41rem;

          &:after{
            content: '';
            width: 41rem;
            height: 3rem;
            background: #0FC29A;
            position: absolute;
            top: 50%;
            right: 100%;
            margin-top: -2rem;
          }
        }

        .isTrue-top{
          bottom: 100%;
          margin-bottom: 41rem;
          left: 50%;
          top: auto;
          transform: translateX(-50%);

          &:after{
            content: '';
            width: 3rem;
            height: 41rem;
            background: #0FC29A;
            position: absolute;
            left: 50%;
            top: 100%;
            margin-left: -2rem;
          }
        }

        .isTrue-in-block{
          width: 100%;
          height: 100%;
          background: transparent;
          color: #333;
          font-size: 28rem;
          top: 0;
          left: 0;
          transform: none;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;

          &:after{
            display: none;
          }
        }
      }

      .action-position-no-center-item{
        &:before{
          display: none;
        }
      }
    }


    .item-has-connection{
      border: 2rem solid transparent;
    }
  }
}
/deep/.el-radio{
  .el-radio__label{
    vertical-align: middle;
  }
}

.action-jigsaw-container-mobile{
  margin-top: 60rem;
  
  .reset{
    width: 44rem;
    height: 44rem;
    top: -104rem;
  }
  /deep/.el-radio{
    .el-radio__label{
      font-size: 24rem !important;
    }
  }
}
  
/deep/.el-radio{
  display: block;
  margin-bottom: 15rem;
  padding-left: 20rem;
  color: #333;

  &:last-child{
    margin-bottom: 10rem;
  }

  .el-radio__label{
    margin-left: 5rem;
    padding: 5rem;
    font-size: 16rem;
  }
  .el-radio__input.is-checked .el-radio__inner{
    border-color: #0FC29A;
    background: #0FC29A;
  }
  .el-radio__input.is-checked+.el-radio__label{
    color: #606266;
  }
  .el-radio__inner:hover{
    border-color: #0FC29A;
  }
}
</style>